module.exports = __webpack_public_path__ + "static/Vazir-Bold-66676f02612fc49e0911cf1b7e3082af.eot";